import { Component, Input } from '@angular/core';
import { ThemeColor } from '../../enums/theme';

export type ContainerColor =
  | ThemeColor
  | 'white'
  | 'primary-lighter'
  | 'primary-default-lighter'
  | 'gray-lighter'
  | 'accent-lighter'
  | 'peach-lighter'
  | 'yellow-darker'
  | 'yellow-lighter'
  | 'warn-lighter';
export type IconColor = ContainerColor | 'black';

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss']
})
export class AvatarComponent {
  @Input() icon!: string;
  @Input() containerSize = 100;
  @Input() maxContainerSize = 100;
  @Input() containerColor: ContainerColor = 'white';
  @Input() iconColor: IconColor = 'primary';
  @Input() iconSize = 30;
  @Input() maxIconSize = 50;
  @Input() imageUrl: string | null = null;
  @Input() shape: 'circle' | 'square' = 'circle';

  constructor() {}
}
